<modal-component>
	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<p class="_title" [translate]="'BEEGO_APPOINTMENT.DELETE_APPOINTMENT.TITLE'"></p>
		</div>

		<p class="_info">
			<info-line icon="./assets/icons/absent-outline.svg" align="top" >
				<p [innerHTML]="'BEEGO_APPOINTMENT.CANCEL_INFO' | translate"></p>
			</info-line>
		</p>
	</ng-container>	

	<!-- RIGHT -->
	<ng-container right>
		<form [formGroup]="deleteAppointmentForm" *ngIf="deleteAppointmentForm">
			<p class="_title" [translate]="'BEEGO_APPOINTMENT.DELETE_APPOINTMENT.REASON_TITLE'"></p>
			<form-textarea label="{{ 'BEEGO_APPOINTMENT.DELETE_APPOINTMENT.REASON_LABEL' | translate }}" [formControl]="deleteAppointmentForm.get('reason') | cast"></form-textarea>
			<form-communication-component [replyTo]="deleteAppointmentForm.get('replyTo') | cast" [telephone]="deleteAppointmentForm.get('telephone') | cast" [communication]="communication"></form-communication-component>
		</form>	

		<p *ngIf="this.confirmation">
			{{'BEEGO_APPOINTMENT.DETAILS.CANCELLED.CONFIRMATION' | translate}}
		</p>
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
	
 		<!-- Annulation > 24H -->
		 <ng-container *ngIf="this.distanceToNow >= 24 ">
			<button class="_button _delete-button" (click)="this.deleteAppointment()">
				<span [translate]="'BEEGO_APPOINTMENT.DELETE'"></span>
			</button>
			<button class="_button _cancel-button" [translate]="'BACK'" (click)="close()"></button>
		 </ng-container>


		<!-- Annulation < 24H -->
		<div class="_info _actionable" *ngIf="this.distanceToNow >= 2 && this.distanceToNow < 24">
			<p [translate]="'BEEGO_APPOINTMENT.DELETE_APPOINTMENT.LESS_THAN_24H'"></p>

			<div class="_buttons">
				<button class="_button _delete-button" (click)="this.deleteAppointment(true)">
					<span [translate]="'BEEGO_APPOINTMENT.DELETE'"></span>
				</button>
				<button class="_button _cancel-button" [translate]="'BACK'" (click)="close()"></button>
			</div>
		</div>

		<!-- Annulation < 2H -->
		<div class="_info _actionable" *ngIf="this.distanceToNow < 2" (click)="this.deleteAppointment()">
			<p [innerHTML]="'BEEGO_APPOINTMENT.DELETE_APPOINTMENT.LESS_THAN_2H' | translate"></p>
			<button class="_button _cancel-button" [translate]="'BACK'" (click)="close()"></button>
		</div>

		
	</ng-container>
</modal-component>
